import reducerGenerator from '../utils/reducer-generator';
import cruReducerHelper from '../utils/cru-reducer-helper';
import requestStatuses from '../utils/request-statuses';

var read = reducerGenerator('read', requestStatuses.PENDING);
var readFail = reducerGenerator('read', requestStatuses.FAILED);
var readNull = reducerGenerator('read', requestStatuses.NULL);

function readSucceed(state, action, options) {
  return cruReducerHelper(state, action, options, {
    readStatus: requestStatuses.SUCCEEDED
  });
}

export { read, readFail, readNull, readSucceed };


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-resource/es/request-statuses-plugin/read.js
// module id = 1024
// module chunks = 2